// components/DriverBlock.jsx
import React from "react";

const DriverBlock = ({ block }) => {
  return (
    <div className="bg-[#010d50] p-6 md:p-8 rounded-3xl shadow-lg flex flex-col md:flex-row items-start md:items-center">
      <img
        src={block.icon}
        alt="Icon"
        className="h-12 w-12 md:h-14 md:w-14 text-blue-400 mb-4 md:mb-0 md:mr-4"
      />
      <div>
        <h3 className="text-lg md:text-xl pb-3 md:pb-5">{block.title}</h3>
        <p className="text-sm md:text-md text-gray-300">{block.content}</p>
      </div>
    </div>
  );
};

export default DriverBlock;